'use client';

import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, ShieldCheck, Check } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function CTASection() {
  return (
    <section className="py-14 sm:py-16 md:py-20 bg-gradient-to-r from-[#082846] via-primary to-[#082846] dark:from-card dark:via-background dark:to-card text-white dark:text-foreground border-y border-transparent dark:border-border/80 relative overflow-hidden transition-colors duration-300">
      {/* Background ambient lighting */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-96 h-96 bg-white/10 dark:bg-primary/15 rounded-full blur-[100px] pointer-events-none" />

      <div className="container-landing relative z-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 dark:bg-primary/15 border border-white/20 dark:border-primary/30 text-blue-100 dark:text-primary text-xs font-semibold uppercase tracking-wider mb-4">
              <Sparkles className="w-3.5 h-3.5 text-amber-300" />
              <span>Comece Agora</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white dark:text-foreground tracking-tight mb-3">
              Saúde não precisa esperar.
            </h2>

            <p className="text-base sm:text-lg text-blue-100/90 dark:text-muted-foreground leading-relaxed max-w-xl">
              Encontre o profissional certo, consulte avaliações de pacientes reais e receba atendimento médico seguro em poucos minutos.
            </p>

            <div className="flex flex-wrap items-center gap-4 text-xs text-blue-200 dark:text-muted-foreground mt-5">
              <span className="flex items-center gap-1.5 font-medium">
                <Check className="w-4 h-4 text-emerald-300 dark:text-emerald-400" />
                Sem mensalidade ou fidelidade
              </span>
              <span className="text-white/30 dark:text-border hidden sm:inline">•</span>
              <span className="flex items-center gap-1.5 font-medium">
                <ShieldCheck className="w-4 h-4 text-emerald-300 dark:text-emerald-400" />
                Receitas e atestados válidos em todo o Brasil
              </span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <Link to="/register">
              <Button
                variant="primary"
                size="lg"
                className="w-full sm:w-auto rounded-xl font-bold bg-white text-primary hover:bg-white/90 dark:bg-primary dark:text-primary-foreground dark:hover:bg-primary-hover gap-2 shadow-xl hover:shadow-2xl dark:shadow-primary/25 hover:scale-105 transition-all text-base px-8 py-4"
              >
                <span>Encontrar meu médico agora</span>
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
